import { render, staticRenderFns } from "./requerimiento-autoridad-editar.vue?vue&type=template&id=1f3ebcab&"
import script from "./requerimiento-autoridad-editar.vue?vue&type=script&lang=js&"
export * from "./requerimiento-autoridad-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports